import Hammer from 'hammerjs'
import {app} from './initializePixi'
import EventManager from "./lib/EventManager";
import state from "./State";

const hammertime = new Hammer(document.body)
hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });

hammertime.on('swipe', function(ev) {
  if (state.orientation === 'portrait') {
    switch (ev.direction) {
      case Hammer.DIRECTION_RIGHT:
        EventManager.emit('move', 'up')
        break;
      case Hammer.DIRECTION_LEFT:
        EventManager.emit('move', 'down')
        break;
      case Hammer.DIRECTION_UP:
        EventManager.emit('move', 'left')
        break;
      case Hammer.DIRECTION_DOWN:
        EventManager.emit('move', 'right')
        break;
    }
  }
})
